import qs from 'query-string'
import type { IDashboardFilter, IRequestModelFieldnameSuggestions } from '@looker/sdk'
import type { LookerCookielessSession, LookerSdkSession } from '@zendesk/zqa-services/users'

import { api } from '@/api'
import { session } from '@/composables/useSession'

import type { InitialAssignmentFilter, LookerDashboard } from '../looker/types'

export const getLookerDashboards = () =>
  api
    .get('looker/dashboards', { headers: { 'X-Klaus-Workspace': session.workspace.id.toString() } })
    .json<{ dashboards: LookerDashboard[]; lookerRegionalInstance?: string }>()

export const getInitialAssignmentFilterData = async () => {
  return await api
    .get('assignments/v2/looker/filter', { headers: { 'X-Klaus-Workspace': session.workspace.id.toString() } })
    .json<InitialAssignmentFilter>()
}

export const getLookerSession = (id: string) =>
  api
    .get('looker/session', { searchParams: { dashboardId: id } })
    .json<LookerCookielessSession>()
    .then((session) => ({
      authentication_token: session.authenticationToken,
      authentication_token_ttl: Number(session.authenticationTokenTtl),
      navigation_token: session.navigationToken,
      navigation_token_ttl: Number(session.navigationTokenTtl),
      api_token: session.apiToken,
      api_token_ttl: Number(session.apiTokenTtl),
      // Needed for embed SDK
      session_reference_token_ttl: NaN,
    }))

export const getLookerSDKToken = (id: string) =>
  api
    .get('looker/sdk', { searchParams: { dashboardId: id } })
    .json<LookerSdkSession>()
    .then((tokenResponse) => ({
      access_token: tokenResponse.accessToken,
      token_type: tokenResponse.tokenType,
      expires_in: tokenResponse.expiresIn != null ? parseInt(tokenResponse.expiresIn, 10) : null,
      refresh_token: tokenResponse.refreshToken,
    }))

export const getLookerDashboardFilters = (id: string) =>
  api.get(`looker/dashboards/${id}/filters`).json<{ dashboard_filters: IDashboardFilter[] }>()

export const getLookerFilterFieldSuggestions = ({
  model_name,
  view_name,
  field_name,
  term,
  filters,
}: IRequestModelFieldnameSuggestions) =>
  api
    .get(`looker/models/${model_name}/views/${view_name}/fields/${field_name}/suggestions`, {
      searchParams: qs.stringify({ term, filters }),
    })
    .json()
